module.exports = {
	"defaults": {
		"format": "%s%v",
		"noSymbolFormat": "%s %v",
		"decimal": ".",
		"thousand": ","
	},
	"locales": {
		"f": {
			"%s %v": [
				"ar",
				"ar-AE",
				"ar-BH",
				"ar-DJ",
				"ar-DZ",
				"ar-EG",
				"ar-EH",
				"ar-ER",
				"ar-IL",
				"ar-IQ",
				"ar-JO",
				"ar-KM",
				"ar-KW",
				"ar-LB",
				"ar-LY",
				"ar-MA",
				"ar-MR",
				"ar-OM",
				"ar-PS",
				"ar-QA",
				"ar-SA",
				"ar-SD",
				"ar-SO",
				"ar-SS",
				"ar-SY",
				"ar-TD",
				"ar-TN",
				"ar-YE",
				"az",
				"az-Latn",
				"de-AT",
				"de-CH",
				"de-LI",
				"en-AT",
				"en-CH",
				"en-IN",
				"en-NL",
				"en-US-POSIX",
				"es-AR",
				"es-CO",
				"es-PY",
				"es-UY",
				"fr-CH",
				"hy",
				"it-CH",
				"mk",
				"mn",
				"ms-BN",
				"my",
				"nb",
				"nb-SJ",
				"ne",
				"ne-IN",
				"nl",
				"nl-AW",
				"nl-BQ",
				"nl-CW",
				"nl-SR",
				"nl-SX",
				"pa",
				"pa-Guru",
				"root",
				"ta",
				"ta-LK",
				"ta-MY",
				"ta-SG",
				"to",
				"ur",
				"ur-IN",
				"vi"
			],
			"%v %s": [
				"be",
				"bg",
				"bs",
				"bs-Latn",
				"ca",
				"ca-AD",
				"ca-ES-VALENCIA",
				"ca-FR",
				"ca-IT",
				"cs",
				"da",
				"da-GL",
				"de",
				"de-BE",
				"de-LU",
				"el",
				"el-CY",
				"en-150",
				"en-BE",
				"en-DE",
				"en-DK",
				"en-FI",
				"en-SE",
				"en-SI",
				"es",
				"es-EA",
				"es-IC",
				"es-PH",
				"et",
				"eu",
				"fi",
				"fo",
				"fo-DK",
				"fr",
				"fr-BE",
				"fr-BF",
				"fr-BI",
				"fr-BJ",
				"fr-BL",
				"fr-CA",
				"fr-CD",
				"fr-CF",
				"fr-CG",
				"fr-CI",
				"fr-CM",
				"fr-DJ",
				"fr-DZ",
				"fr-GA",
				"fr-GF",
				"fr-GN",
				"fr-GP",
				"fr-GQ",
				"fr-HT",
				"fr-KM",
				"fr-LU",
				"fr-MA",
				"fr-MC",
				"fr-MF",
				"fr-MG",
				"fr-ML",
				"fr-MQ",
				"fr-MR",
				"fr-MU",
				"fr-NC",
				"fr-NE",
				"fr-PF",
				"fr-PM",
				"fr-RE",
				"fr-RW",
				"fr-SC",
				"fr-SN",
				"fr-SY",
				"fr-TD",
				"fr-TG",
				"fr-TN",
				"fr-VU",
				"fr-WF",
				"fr-YT",
				"he",
				"hr",
				"hr-BA",
				"hu",
				"is",
				"it",
				"it-SM",
				"ka",
				"kk",
				"ky",
				"lt",
				"lv",
				"nl-BE",
				"pl",
				"pt-AO",
				"pt-CV",
				"pt-GW",
				"pt-MO",
				"pt-MZ",
				"pt-PT",
				"pt-ST",
				"pt-TL",
				"ro",
				"ro-MD",
				"ru",
				"ru-BY",
				"ru-KG",
				"ru-KZ",
				"ru-MD",
				"ru-UA",
				"sk",
				"sl",
				"sq",
				"sq-MK",
				"sq-XK",
				"sr",
				"sr-Cyrl",
				"sr-Cyrl-BA",
				"sr-Cyrl-ME",
				"sr-Cyrl-XK",
				"sr-Latn",
				"sr-Latn-BA",
				"sr-Latn-ME",
				"sr-Latn-XK",
				"sv",
				"sv-SE",
				"sv-AX",
				"sv-FI",
				"tr",
				"tr-CY",
				"uk",
				"uz",
				"uz-Latn"
			],
			"%v%s": [
				"bn",
				"bn-IN"
			]
		},
		"d": {
			",": [
				"af",
				"af-NA",
				"ar-DZ",
				"ar-LB",
				"ar-LY",
				"ar-MA",
				"ar-MR",
				"ar-TN",
				"az",
				"az-Latn",
				"be",
				"bg",
				"bs",
				"bs-Latn",
				"ca",
				"ca-AD",
				"ca-ES-VALENCIA",
				"ca-FR",
				"ca-IT",
				"cs",
				"da",
				"da-GL",
				"de",
				"de-AT",
				"de-BE",
				"de-LU",
				"el",
				"el-CY",
				"en-150",
				"en-AT",
				"en-BE",
				"en-CH",
				"en-DE",
				"en-DK",
				"en-FI",
				"en-NL",
				"en-SE",
				"en-SI",
				"en-ZA",
				"es",
				"es-AR",
				"es-BO",
				"es-CL",
				"es-CO",
				"es-CR",
				"es-EA",
				"es-EC",
				"es-GQ",
				"es-IC",
				"es-PH",
				"es-PY",
				"es-UY",
				"es-VE",
				"et",
				"eu",
				"fi",
				"fo",
				"fo-DK",
				"fr",
				"fr-BE",
				"fr-BF",
				"fr-BI",
				"fr-BJ",
				"fr-BL",
				"fr-CA",
				"fr-CD",
				"fr-CF",
				"fr-CG",
				"fr-CI",
				"fr-CM",
				"fr-DJ",
				"fr-DZ",
				"fr-GA",
				"fr-GF",
				"fr-GN",
				"fr-GP",
				"fr-GQ",
				"fr-HT",
				"fr-KM",
				"fr-LU",
				"fr-MA",
				"fr-MC",
				"fr-MF",
				"fr-MG",
				"fr-ML",
				"fr-MQ",
				"fr-MR",
				"fr-MU",
				"fr-NC",
				"fr-NE",
				"fr-PF",
				"fr-PM",
				"fr-RE",
				"fr-RW",
				"fr-SC",
				"fr-SN",
				"fr-SY",
				"fr-TD",
				"fr-TG",
				"fr-TN",
				"fr-VU",
				"fr-WF",
				"fr-YT",
				"gl",
				"hr",
				"hr-BA",
				"hu",
				"hy",
				"id",
				"is",
				"it",
				"it-SM",
				"ka",
				"kk",
				"km",
				"ky",
				"lo",
				"lt",
				"lv",
				"mk",
				"ms-BN",
				"nb",
				"nb-SJ",
				"nl",
				"nl-AW",
				"nl-BE",
				"nl-BQ",
				"nl-CW",
				"nl-SR",
				"nl-SX",
				"pl",
				"pt",
				"pt-AO",
				"pt-CV",
				"pt-GW",
				"pt-MO",
				"pt-MZ",
				"pt-PT",
				"pt-ST",
				"pt-TL",
				"ro",
				"ro-MD",
				"ru",
				"ru-BY",
				"ru-KG",
				"ru-KZ",
				"ru-MD",
				"ru-UA",
				"sk",
				"sl",
				"sq",
				"sq-MK",
				"sq-XK",
				"sr",
				"sr-Cyrl",
				"sr-Cyrl-BA",
				"sr-Cyrl-ME",
				"sr-Cyrl-XK",
				"sr-Latn",
				"sr-Latn-BA",
				"sr-Latn-ME",
				"sr-Latn-XK",
				"sv",
				"sv-SE",
				"sv-AX",
				"sv-FI",
				"sw-CD",
				"tr",
				"tr-CY",
				"uk",
				"uz",
				"uz-Latn",
				"vi"
			]
		},
		"t": {
			" ": [
				"af",
				"af-NA",
				"be",
				"bg",
				"cs",
				"de-AT",
				"en-FI",
				"en-SE",
				"en-ZA",
				"es-CR",
				"et",
				"fi",
				"fr",
				"fr-BF",
				"fr-BI",
				"fr-BJ",
				"fr-BL",
				"fr-CA",
				"fr-CD",
				"fr-CF",
				"fr-CG",
				"fr-CH",
				"fr-CI",
				"fr-CM",
				"fr-DJ",
				"fr-DZ",
				"fr-GA",
				"fr-GF",
				"fr-GN",
				"fr-GP",
				"fr-GQ",
				"fr-HT",
				"fr-KM",
				"fr-MC",
				"fr-MF",
				"fr-MG",
				"fr-ML",
				"fr-MQ",
				"fr-MR",
				"fr-MU",
				"fr-NC",
				"fr-NE",
				"fr-PF",
				"fr-PM",
				"fr-RE",
				"fr-RW",
				"fr-SC",
				"fr-SN",
				"fr-SY",
				"fr-TD",
				"fr-TG",
				"fr-TN",
				"fr-VU",
				"fr-WF",
				"fr-YT",
				"hu",
				"ka",
				"kk",
				"ky",
				"lt",
				"lv",
				"nb",
				"nb-SJ",
				"pl",
				"pt-AO",
				"pt-CV",
				"pt-GW",
				"pt-MO",
				"pt-MZ",
				"pt-PT",
				"pt-ST",
				"pt-TL",
				"ru",
				"ru-BY",
				"ru-KG",
				"ru-KZ",
				"ru-MD",
				"ru-UA",
				"sk",
				"sq",
				"sq-MK",
				"sq-XK",
				"sv",
				"sv-SE",
				"sv-AX",
				"sv-FI",
				"uk",
				"uz",
				"uz-Latn"
			],
			".": [
				"ar-DZ",
				"ar-LB",
				"ar-LY",
				"ar-MA",
				"ar-MR",
				"ar-TN",
				"az",
				"az-Latn",
				"bs",
				"bs-Latn",
				"ca",
				"ca-AD",
				"ca-ES-VALENCIA",
				"ca-FR",
				"ca-IT",
				"da",
				"da-GL",
				"de",
				"de-BE",
				"de-LU",
				"el",
				"el-CY",
				"en-150",
				"en-AT",
				"en-BE",
				"en-CH",
				"en-DE",
				"en-DK",
				"en-NL",
				"en-SI",
				"es",
				"es-AR",
				"es-BO",
				"es-CL",
				"es-CO",
				"es-EA",
				"es-EC",
				"es-GQ",
				"es-IC",
				"es-PH",
				"es-PY",
				"es-UY",
				"es-VE",
				"eu",
				"fo",
				"fo-DK",
				"fr-BE",
				"fr-LU",
				"fr-MA",
				"gl",
				"hr",
				"hr-BA",
				"hy",
				"id",
				"is",
				"it",
				"it-SM",
				"km",
				"lo",
				"mk",
				"ms-BN",
				"nl",
				"nl-AW",
				"nl-BE",
				"nl-BQ",
				"nl-CW",
				"nl-SR",
				"nl-SX",
				"pt",
				"ro",
				"ro-MD",
				"sl",
				"sr",
				"sr-Cyrl",
				"sr-Cyrl-BA",
				"sr-Cyrl-ME",
				"sr-Cyrl-XK",
				"sr-Latn",
				"sr-Latn-BA",
				"sr-Latn-ME",
				"sr-Latn-XK",
				"sw-CD",
				"tr",
				"tr-CY",
				"vi"
			],
			"'": [
				"de-CH",
				"de-LI",
				"it-CH"
			]
		}
	},
	"currencies": {
		"s": {
			"€": [
				"EUR"
			],
			"£": [
				"GBP"
			],
			"kr": [
				"DKK",
				"SEK",
				"NOK"
			],
			"$": [
				"AUD",
				"CAD",
				"NZD",
				"USD",
				"HKD",
				"SGD"
			],
			"Դ": [
				"AMD"
			],
			"R$": [
				"BRL"
			],
			"Kč": [
				"CZK"
			],
			"¥": [
				"JPY",
				"CNY"
			],
			"zł": [
				"PLN"
			],
			"Ft": [
				"HUF"
			],
			"₦": [
				"NGN"
			],
			"৳": [
				"BDT"
			],
			"CHF": [
				"CHF"
			],
			"Rp": [
				"IDR"
			],
			"₩": [
				"KRW"
			],
			"₨": [
				"LKR"
			],
			"RM": [
				"MYR"
			],
			"C$": [
				"NIO"
			],
			"₱": [
				"PHP"
			],
			"฿": [
				"THB"
			],
			"R": [
				"ZAR"
			],
			"₺": [
				"TRY"
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./config/currency.json
// module id = 178
// module chunks = 3